import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../typography'

import Icon from '../icon/index'
import ArrowDown from '../icon/chevron-down.svg'

import styles from '../../../styles/bantrab/components/card.module.scss'

const CourseMediumDefault = ({ labelId, question, answer, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.courseMediumDefault]: true
  })

  return (
    <div {...attrs}>
      <input id={labelId} type="checkbox" />
      <label htmlFor={labelId}>
        <figure className="mr-4 ml-8"><Icon className="text-green-500" svg={ArrowDown} size={24} /></figure>
        <Typography className="text-gray-500" tag="h1" size="four" weight="bold">{question}</Typography>
      </label>
      <div className="mr-8">
        <p>{answer}</p>
      </div>
    </div>
  )
}

CourseMediumDefault.propTypes = {
  labelId: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  question: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  answer: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default CourseMediumDefault
